import { removeQueryStringFromUri } from './removeQueryStringFromUri';

export const removeSearchIdentifierFromLinkNode = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    node: Record<string, any>
) => {
    return {
        ...node,
        data: {
            ...node['data'],
            uri: removeQueryStringFromUri(node['data'].uri, 'search_identifier')
        }
    };
};
